// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuthController from "./auth_controller"
application.register("auth", AuthController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ContactsSetupController from "./contacts_setup_controller"
application.register("contacts-setup", ContactsSetupController)

import DarkModeController from "./dark_mode_controller"
application.register("dark-mode", DarkModeController)

import GlobalsController from "./globals_controller"
application.register("globals", GlobalsController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import LiveJournalController from "./live_journal_controller"
application.register("live-journal", LiveJournalController)

import LogViewerController from "./log_viewer_controller"
application.register("log-viewer", LogViewerController)

import PlatformSnifferController from "./platform_sniffer_controller"
application.register("platform-sniffer", PlatformSnifferController)

import ProfileSetupController from "./profile_setup_controller"
application.register("profile-setup", ProfileSetupController)

import QrCodeController from "./qr_code_controller"
application.register("qr-code", QrCodeController)

import SwitcherController from "./switcher_controller"
application.register("switcher", SwitcherController)

import ThumbdataController from "./thumbdata_controller"
application.register("thumbdata", ThumbdataController)

import TimeZoneController from "./time_zone_controller"
application.register("time-zone", TimeZoneController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)
